var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('notifications',{staticClass:"mt-2",attrs:{"group":"task-error","classes":"vue-notification text-lg"},nativeOn:{"click":function($event){return _vm.goToBoard.apply(null, arguments)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }